/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Biochemistry17Inputs */

const en__field_enum_study_biochemistry17 = /** @type {(inputs: _Field_Enum_Study_Biochemistry17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biochemistry`)
};

const de__field_enum_study_biochemistry17 = /** @type {(inputs: _Field_Enum_Study_Biochemistry17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biochemie`)
};

/**
* | output |
* | --- |
* | "Biochemistry" |
*
* @param {_Field_Enum_Study_Biochemistry17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_biochemistry17 = /** @type {((inputs?: _Field_Enum_Study_Biochemistry17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Biochemistry17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_biochemistry17(inputs)
	return de__field_enum_study_biochemistry17(inputs)
});
export { _field_enum_study_biochemistry17 as "_field_enum_STUDY_BIOCHEMISTRY" }